import React from 'react';
import { connect } from 'react-redux';

import styled from 'styled-components';

import ColoredSectionContainer from 'apps/promo/components/common/ColoredSectionContainer';
import { PromoPageContainer } from 'apps/promo/components/common/promo-page-container/PromoPageContainer';
import { PromoText } from 'apps/promo/components/common/promo-text/PromoText';
import { PromoRow } from 'apps/promo/components/common/PromoRow/PromoRow';
import HeadingSection from 'apps/promo/components/common/sections/HeadingSection';
import NotAuthBasePage from 'apps/promo/components/NotAuthBasePage';
import { useGetQueryParams } from 'apps/promo/components/utils';
import { resolveArguments } from 'apps/promo/helpers/utils';
import promoColors from 'apps/promo/theme/promoColors';
import promoMedia from 'apps/promo/theme/promoMedia';

const StateTerm = styled.div`
    margin-bottom: 12px;
`;
const StateFrames = styled.div`
    & > div,
    & > ul {
        flex: 1;
    }

    li + li {
        margin-top: 24px;
    }

    ${promoMedia.tablet744} {
        display: flex;
        justify-content: space-between;
    }
`;
const States = styled.ul`
    & > li {
        border-top: 1px solid ${promoColors.gray5};
        padding: 32px 0 0;

        & + li {
            margin-top: 32px;
        }
    }
`;

const LicensePage = (props) => {
    const data = [props.sectionText1, props.sectionText2, props.sectionText3];

    const urlParams = useGetQueryParams();

    const getDescription = () => {
        if (data.length > 0) {
            let description = data
                .filter((item) => item !== null)
                .map((text) => `<p>${text}</p>`)
                .join('');

            description = resolveArguments(description, urlParams.version === 'c3p0' ? props.license_bank_3_0 : props.license_bank_2_0);

            return description;
        } else {
            return '';
        }
    };

    return (
        <PromoPageContainer hasTopPadding>
            <ColoredSectionContainer doubleTopPadding={!props.sectionTitle}>
                {props.sectionTitle && <HeadingSection title={props.sectionTitle} text={getDescription()} textLeft />}
                {props.stateData && (
                    <States>
                        {props.stateData.map((data, index) => {
                            return (
                                <li key={index}>
                                    <StateFrames>
                                        <PromoRow indent="32px">
                                            <PromoText tag="p" variant="subheader">
                                                {data.name}
                                            </PromoText>
                                        </PromoRow>
                                        <ul>
                                            <li>
                                                <StateTerm>
                                                    <PromoText tag="div" variant="note" color="gray40">
                                                        {props.tableTitleAgency}
                                                    </PromoText>
                                                </StateTerm>
                                                <PromoText tag="p">{data.regulatory}</PromoText>
                                            </li>
                                            <li>
                                                <StateTerm>
                                                    <PromoText tag="div" variant="note" color="gray40">
                                                        {props.tableTitleLicense}
                                                    </PromoText>
                                                </StateTerm>
                                                <PromoText tag="p">{data.license}</PromoText>
                                            </li>
                                            <li>
                                                <StateTerm>
                                                    <PromoText tag="div" variant="note" color="gray40">
                                                        {props.tableTitleStatue}
                                                    </PromoText>
                                                </StateTerm>
                                                <PromoText tag="p">{data.statue}</PromoText>
                                            </li>
                                        </ul>
                                    </StateFrames>
                                </li>
                            );
                        })}
                    </States>
                )}
            </ColoredSectionContainer>
        </PromoPageContainer>
    );
};
const mapStateToProps = ({ extra }) => ({
    sectionTitle: extra.strapiApi?.title,
    sectionText1: extra.strapiApi?.text1,
    sectionText2: extra.strapiApi?.text2,
    sectionText3: extra.strapiApi?.text3,
    stateData: extra.strapiApi?.state_info,
    tableTitleLicense: extra.strapiApi?.title_license,
    tableTitleAgency: extra.strapiApi?.title_agency,
    tableTitleStatue: extra.strapiApi?.title_statue,
    license_bank_2_0: extra.strapiApi?.license_bank_2_0,
    license_bank_3_0: extra.strapiApi?.license_bank_3_0,
});
export default connect(mapStateToProps)(NotAuthBasePage(LicensePage));
